/**
 * Patches Shopify.formatMoney to support currency format tokens that the
 * bundled implementation doesn't handle (e.g. {{amount_with_space_separator}}
 * and {{amount_no_decimals_with_space_separator}}, used by Swedish-style
 * "5 950,00 kr" formatting). Without this, the price silently renders blank
 * whenever the current presentment currency uses one of these tokens.
 *
 * This wraps the existing function rather than replacing it, so every
 * previously-working format continues to behave exactly as before.
 */
(function () {
  if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') {
    return;
  }

  var originalFormatMoney = Shopify.formatMoney;
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  var supportedTokens = [
    'amount',
    'amount_no_decimals',
    'amount_with_comma_separator',
    'amount_no_decimals_with_comma_separator',
    'amount_with_apostrophe_separator'
  ];

  Shopify.formatMoney = function (cents, format) {
    var formatString = format || this.money_format;
    var match = formatString && formatString.match(placeholderRegex);

    if (!match || supportedTokens.indexOf(match[1]) !== -1) {
      // Known token (or no token at all) - defer to the original implementation.
      return originalFormatMoney.call(this, cents, format);
    }

    // Unrecognised token, e.g. amount_with_space_separator or
    // amount_no_decimals_with_space_separator. Format it ourselves using a
    // space as the thousands separator and a comma as the decimal mark,
    // matching Shopify's own server-side Liquid `money` filter output.
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    if (isNaN(cents) || cents === null) {
      return formatString.replace(placeholderRegex, '0');
    }

    var noDecimals = match[1].indexOf('no_decimals') > -1;
    var precision = noDecimals ? 0 : 2;
    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var wholePart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    var decimalPart = parts[1] ? ',' + parts[1] : '';
    var value = wholePart + decimalPart;

    return formatString.replace(placeholderRegex, value);
  };
})();
